
const sleep = m => new Promise(r => setTimeout(r, m));
const carroucel_full = require('../carousel-full/carousel-full.script');

const start = async function(videoId) {
    try {

        

        var id = "main_carroucel_banners_full"
        await carroucel_full.start(id)
        await sleep(300);
        var video = document.getElementById(`${id}_0`)
        console.log(`${videoId}_0`, video)
        if (video) {
            video.muted = true;
            video.autoplay = true;
            video.loop = true;
            video.play()
        } else {
            console.log('video not found')
        }
    } catch (err) {
        console.log('carroucel_full not found')
    }
}



const stop = async function(videoId) {
    return true
}


module.exports = {
    start,
    stop
}
